/* ==========================================================================
   Imports
   ========================================================================== */
global.jQuery = global.$ = require('jquery/dist/jquery.js')
global.numeral = require('numeral/src/numeral.js');

require('foundation-sites');
require('jquery.cookie');

// /* ==========================================================================
// Globals
//  ========================================================================== */
require('./globals/foundation.js');
require('./globals/header.js');
require('./globals/back-to-top.js');
require('./globals/mediaIs.zion.js');

/* ==========================================================================
 Components
 ========================================================================== */
require('./components/masthead.js');
require('./components/form.js');
require('./components/slick.js');
require('./components/lity.js');
require('./components/vid_gallery_carousel.js');
require('./components/video_gallery.js');
require('./components/risk_icons.js');
require('./components/parallax.js');
require('./components/testimonials.js');
require('./components/icon_list.js');
require('./components/progression_bar.js');
require('./components/infographic.js');
require('./components/newsletter-signup.js');
require('./components/animated-logo.js');
require('./components/physician-form.js');

// /* ==========================================================================
//  Pages
//  ========================================================================== */
require('./pages/page-for-healthcare-professionals.js');
require('./pages/_find-a-physician.js');

// /* ==========================================================================
//  Third Party
//  ========================================================================== */
require('./third-party/blend-mode.js')

// /* ==========================================================================
//  ACF
//  ========================================================================== */
require('./acf/acf-scripts.js')